import React from "react";
import {NavLink as Links, Route, Switch, useRouteMatch,} from "react-router-dom";
import Error404 from "../../../Components/Error404";
import PurchaseReport from "./PurchaseReport";
import SalesReport from "./SalesReport";

export default function Report(props) {
  const { url } = useRouteMatch();
  return (
    <div>
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h1 className="header-title">
              <strong>Sales & Purchase </strong> Reports
              <small>Generate, Export Reports</small>
            </h1>
          </div>
          <div className="right gap-items-2">
            {props.location.pathname !== url ? (
              <Links
                className="btn btn-mute btn-square btn-round"
                activeClassName="active"
                to={url}
              >
                <span className="material-icons-outlined">arrow_back</span>
              </Links>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="header-action">
          <nav className="nav">
            {/* <Links to={url} className="nav-link">
              Summary
            </Links> */}
            <Links
              to={`${url}/Sales`}
              className={`nav-link ${
                props.location.pathname === "/Sales" ? "active" : ""
              }`}
            >
              Sales Report
            </Links>
            <Links
              to={`${url}/Purchase`}
              className={`nav-link ${
                props.location.pathname === "/Purchase" ? "active" : ""
              }`}
            >
              Purchase Report
            </Links>
          </nav>
        </div>
      </header>

      <Switch>
        {/* <Route path={url} exact component={Summary} /> */}
        <Route path={url} exact component={SalesReport} />
        <Route path={`${url}/Sales`} component={SalesReport} />
        <Route path={`${url}/Purchase`} component={PurchaseReport} />
        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </div>
  );
}
